import { inject, Injectable } from '@angular/core';
import { QualityControlViewTableApiService } from '../../../../views/quality-control/api/table.service';
import { forkJoin, Observable } from 'rxjs';
import { User } from '../../../../api/elite/types/users';
import { InspectionApiDto } from '../../../../api/elite/dto/inspection.dto';
import { Inspection } from '../../../../api/elite/types/inspections';
import { ApiRouteScrapService } from '../../../../api/elite/routes/scrap.service';
import { ScrapReason } from '../../../../api/elite/types/scrap-reason';
import { InspectionVisualDto } from '../../../../api/elite/dto/inspection-visual.dto';
import { ApiRouteInspectionMeasureService } from '../../../../api/elite/routes/inspection-measure.service';
import { InspectionMeasureTool } from '../../../../api/elite/types/inspection-assembly-item';

@Injectable()
export class HosesQcViewTableApiService extends QualityControlViewTableApiService {
  protected readonly scrapService = inject(ApiRouteScrapService);
  protected readonly apiMeasureRouter = inject(
    ApiRouteInspectionMeasureService
  );

  override getOpenInspection(
    itemIdForInspection: number,
    query: InspectionApiDto['open']['query'] = {}
  ): Observable<Inspection | undefined> {
    return this.apiInspectionService.checkForOpenInspection(
      itemIdForInspection
    );
  }

  override getInspectors(departmentName: string): Observable<User[]> {
    return this.apiUserRouter.allUsersV2(departmentName, 'inspector');
  }

  getDataForMeasureInspection(departmentName: string): Observable<
    InspectionVisualDto['dataForRegisterMeasureRecords']['result'] & {
      measureTools: InspectionMeasureTool[];
    }
  > {
    return forkJoin({
      operators: this.getInspectors(departmentName),
      scrapReasons: this.getScrapReasons(departmentName),
      measureTools: this.apiMeasureRouter.getTools(),
    });
  }

  getScrapReasons(departmentName: string): Observable<ScrapReason[]> {
    return this.scrapService.getScrapReasons(
      departmentName,
      'Fuera de especificación -'
    );
  }

  // override getDrawingFile(item: string): Observable<GoogleFileT> {
  //   return this.apiFilesRouter
  //     .drawingForHoses(item)
  //     .pipe(map((res) => res.drawing));
  // }
}
